import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check-o-success",
  "use": "icon-check-o-success-usage",
  "viewBox": "0 0 48 49",
  "content": "<symbol viewBox=\"0 0 48 49\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check-o-success\">\n<path d=\"M0 24.0862C0 10.8313 10.7452 0.0861816 24 0.0861816C37.2548 0.0861816 48 10.8313 48 24.0862C48 37.341 37.2548 48.0862 24 48.0862C10.7452 48.0862 0 37.341 0 24.0862Z\" fill=\"#D1FAE5\" />\n<path d=\"M17 25.0862L21 29.0862L31 19.0862\" stroke=\"#059669\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol